var _circle, _path, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "new",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 0.0000038,
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33B49D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A185"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#SVGID_1_)",
    r: 256
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    x1: 42.6666679,
    x2: 469.3333435,
    y1: 256.0005188,
    y2: 256.0005188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A185"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#33B49D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,469.3338623c-117.6309357,0-213.3333282-95.7023926-213.3333282-213.3333435    c0-117.6314545,95.7023926-213.333313,213.3333282-213.333313c117.636261,0,213.3333435,95.7018661,213.3333435,213.333313    C469.3333435,373.6314697,373.636261,469.3338623,256,469.3338623z",
    fill: "url(#SVGID_2_)"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_109_",
    opacity: 0.3,
    points: "384,242.5413361 285.459198,242.5413361 285.459198,144 242.5424042,144    242.5424042,242.5413361 144,242.5413361 144,285.4581299 242.5424042,285.4581299 242.5424042,384 285.459198,384    285.459198,285.4581299 384,285.4581299  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "XMLID_189_",
    points: "376,234.5413361 277.459198,234.5413361 277.459198,136 234.5424042,136    234.5424042,234.5413361 136,234.5413361 136,277.4581299 234.5424042,277.4581299 234.5424042,376 277.459198,376    277.459198,277.4581299 376,277.4581299  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.cb1f617fd7d1a0367acf5648529e82d9.svg";
export { ForwardRef as ReactComponent };